module.exports = __webpack_public_path__ + "img/clock.5e6dcc8c.svg";